import React from "react";
/* eslint-disable */
import {
  Box, Card, Grid, CardContent, Divider, CardHeader,
  TableBody, TableCell, TableContainer, TableHead, TableRow, Table, TableFooter
} from '@material-ui/core';


export default class ComponentToPrint extends React.Component {

  render() {
    const productData = this.props.productList;
    const data = this.props.searchData;
    const totalValues = this.props.totalValues;
    return (
      <div style={{ padding: '10px' }}>
        <h3><center><u>Crop Availability Report</u></center></h3>
        <div>&nbsp;</div>
        {/* <Grid style={{ padding: '20px' }} container spacing={1}>
          <Grid md={2} xs={2}>
            <h4>Group:</h4>
          </Grid>
          <br />

          <Grid md={10} xs={10}>
            {data.groupID}
          </Grid>
          <br />
          <Grid md={2} xs={2}>
            <h4>Fresh Collection Center:  </h4>
          </Grid>
           <Grid md={10} xs={10}>
            {data.operationEntityID}
          </Grid>
          <Grid md={2} xs={2}>
            <h4>Product Category:  </h4>
          </Grid>
          <Grid md={10} xs={10}>
            {data.cropCategoryID}
          </Grid>
          <Grid md={2} xs={2}>
            <h4>Product:</h4>
          </Grid>
          <Grid md={10} xs={10}>
            {data.cropID}
          </Grid> 
        </Grid>*/}



        <div>&nbsp;</div>
        <Box minWidth={1050}>
          <TableContainer style={{ marginLeft: '5px' }}>
            <Table aria-label="caption table">
              <TableHead>
                <TableRow>
                  <TableCell align={'left'}>Farmer Name</TableCell>
                  <TableCell align={'left'}>Supplier Code</TableCell>
                  <TableCell align={'left'}>Fresh Collection Center</TableCell>
                  <TableCell align={'left'}>Product Name</TableCell>
                  <TableCell align={'left'}>Product Code</TableCell>
                  <TableCell align={'left'}>Date</TableCell>
                  <TableCell align={'right'}>Quantity</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {productData.map((data, index) => (
                  <TableRow key={index}>
                    <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {data.firstName}
                    </TableCell>
                     <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {data.supplierCode}
                    </TableCell>
                    <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {data.factoryName}
                    </TableCell>
                    <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {data.productName}
                    </TableCell>
                    <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {data.productCode}
                    </TableCell>
                    <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {new Date(data.cropForecastDate).toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', minimumIntegerDigits: 2 })}
                    </TableCell>
                    <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {data.quantity}
                    </TableCell>
                  </TableRow>
                ))}
                <TableRow>
                  <TableCell sx={{ fontWeight: "bold" }} >Total</TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell sx={{ fontWeight: "bold" }} align='right'>{parseFloat(totalValues.totalQuantity).toFixed(2)}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </div>

    );
  }
}
